import Button from '@material-ui/core/Button'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import React from 'react'
import { Link } from 'react-router-dom'
import Loading from '../../customs/Loading/Loading'
import { EKOM_LINKS } from '../../EKOM_LINKS'
import { ERR_IEN_401, useContractSubmsInfoExtSys } from '../../hooks/useContractSubmsInfoExtSys'
import Error from '../../parts/Error'
import ErrorNotRegisterIen from '../../parts/ErrorNotRegisterIen'
import { useStyles } from './styles'

interface iEkomContractActionsBtn {
  extSystemId: string
  extObjectId: string
  contractSlug?: string
  contractExtUrl?: string
}

const EkomContractActionsBtn = ({
  extSystemId,
  extObjectId,
  contractSlug,
  contractExtUrl,
}: iEkomContractActionsBtn) => {
  const classes = useStyles()

  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const paramsExt = new URLSearchParams()
  paramsExt.append(EKOM_LINKS.queryExtSys, extSystemId)
  paramsExt.append(EKOM_LINKS.queryExtId, extObjectId ?? '')
  const extQueryString = paramsExt.toString()

  const { data, loading, error } = useContractSubmsInfoExtSys(extSystemId, extObjectId)
  if (error) {
    if (contractExtUrl && error === ERR_IEN_401) {
      return <ErrorNotRegisterIen url={contractExtUrl}/>
    }
    return <Error>{error}</Error>
  }
  if (loading) {
    return <Loading/>
  }

  const actionsSubms = data?.typNabidkyZadosti
  const actionsMsg = data?.typyZprav

  return (
    <>
      {!!actionsMsg?.length &&
        <>
          <Button variant="contained" color="primary" className={classes.btnItem}
                  aria-controls="simple-menu" aria-haspopup="true"
                  endIcon={<ExpandMoreIcon/>}
            // endIcon={<ArrowDropDownIcon/>}
                  onClick={handleClick}>
            POSLAT ZPRÁVU ZADAVATELI
          </Button>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            {actionsMsg.map((msg) =>
              <MenuItem
                key={msg.kod}
                className={classes.linkItem}
                component={Link}
                to={contractSlug ?
                  `${EKOM_LINKS.newMsg}/${contractSlug}/${msg.kod}` :
                  `${EKOM_LINKS.newMsgVirtual}/${msg.kod}?${extQueryString}`}
              >
                {msg.nazev}
              </MenuItem>
            )}

          </Menu>
        </>
      }

      {!!actionsSubms?.length &&
        <>
          {actionsSubms.map((subm) =>
            <Button key={subm.kod}
                    variant="contained"
                    color="primary"
                    className={classes.btnItem}
                    component={Link}
                    to={contractSlug ?
                      `${EKOM_LINKS.newSubms}/${contractSlug}/${subm.kod}` :
                      `${EKOM_LINKS.newSubmsVirtual}/${subm.kod}?${extQueryString}`}
            >
              {subm.nazev}
            </Button>
          )}
        </>
      }
    </>
  )

}

export default EkomContractActionsBtn
